export interface SplitButtonOptionModel {
  id: string;
  label: string;
}
